import { render } from "./user_agreement.vue?vue&type=template&id=41445994&scoped=true"
import script from "./user_agreement.vue?vue&type=script&lang=js"
export * from "./user_agreement.vue?vue&type=script&lang=js"

import "./user_agreement.vue?vue&type=style&index=0&id=41445994&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41445994"]])

export default __exports__